import { useContext } from "react"
import {UserContext} from "../Context/UserContext"
import { Table, Button } from "antd"
import { useHistory } from "react-router-dom"


const Profile = () => {
    const history = useHistory()
    const [user] = useContext(UserContext)
    const HandleChangePassword = () => {
        history.push("/profile/change-password")
    }
    const columns = [
        {dataIndex: 'key'},{dataIndex: 'value'}
    ]
    const data = [
        {key: 'nama', value: `${user.name}`},
        {key: 'email', value: `${user.email}`},
        {key: 'password', value: <Button type="primary" size="small" onClick={HandleChangePassword}>Change Password</Button>}
    ]
    return(
        <Table columns={columns} dataSource={data} pagination={false} />
    )
}
export default Profile